<script>
  import { flip } from 'svelte/animate';
  import { selectedChannelId } from '../../../Store/store';
  import {
    listenToChannel,
    updatePlaylist,
    updateAds,
    updateAutoplay,
  } from '../../../Api/playlistApi';

  let list = [];
  let hovering = false;
  let selected;
  let ads;
  let autoplay;
  let inputEl;

  $: $selectedChannelId && getChannelData();

  const updateAdsSelected = async (e) => {
    await updateAds($selectedChannelId, e.target.checked);
  };

  const updateAutoplaySelected = async (e) => {
    await updateAutoplay($selectedChannelId, e.target.checked);
  };

  const getChannelData = async () => {
    await listenToChannel($selectedChannelId, (snapShot) => {
      if (snapShot.exists) {
        selected = { ...snapShot.data(), id: snapShot.id };
        ads = selected.ads;
        autoplay = selected.autoplay;
        list = selected.playlist || [];
      }
    });
  };

  const drop = async (event, target) => {
    if (selected && !selected.live) {
      event.dataTransfer.dropEffect = 'move';
      const start = parseInt(event.dataTransfer.getData('text/plain'));
      const newTracklist = list;

      if (start < target) {
        newTracklist.splice(target + 1, 0, newTracklist[start]);
        newTracklist.splice(start, 1);
      } else {
        newTracklist.splice(target, 0, newTracklist[start]);
        newTracklist.splice(start + 1, 1);
      }
      list = newTracklist;
      await updatePlaylist($selectedChannelId, list);
      hovering = null;
    } else {
      return false;
    }
  };

  const dragstart = (event, i) => {
    if (selected && !selected.live) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
      const start = i;
      event.dataTransfer.setData('text/plain', start);
    } else {
      return false;
    }
  };

  const onDragHovering = () => {
    if (selected && !selected.live) {
      hovering = index;
    }
  };

  const onSaveAsset = async () => {
    if (inputEl) {
      await updatePlaylist($selectedChannelId, [...list, { name: inputEl, id: inputEl }]);
      inputEl = '';
    }
  };

  const onDeleteAsset = async (asset) => {
    await updatePlaylist(
      $selectedChannelId,
      list.filter((l) => l.id !== asset.id),
    );
  };

  const onKeyPress = (e) => {
    if (e.charCode === 13) {
      onSaveAsset();
    }
  };
</script>

<div class="settings">
  <div class="asset-input">
    <input
      disabled={selected && selected.live}
      class="input-box"
      on:keypress={onKeyPress}
      bind:value={inputEl}
      type="text"
    />
    <button disabled={selected && selected.live} class="add-button" on:click={onSaveAsset}
      >+ Ny assetId</button
    >
    <span class="support-message">Obs! Sumoassets støttes ikke.</span>
  </div>

  <div class="checkboxes">
    <label>
      <input
        disabled={selected && selected.live}
        type="checkbox"
        checked={ads}
        on:change={updateAdsSelected}
      />
      Reklame
    </label>
    <label>
      <input
        disabled={selected && selected.live}
        type="checkbox"
        checked={autoplay}
        on:change={updateAutoplaySelected}
      />
      Autoplay
    </label>
  </div>
</div>
{#if list && list.length}
  <div class="list">
    {#each list as n, index (n.id)}
      <div
        class:disabled={selected && selected.live}
        class="list-item"
        animate:flip
        draggable={true}
        on:dragstart={(event) => dragstart(event, index)}
        on:drop|preventDefault={(event) => drop(event, index)}
        ondragover="return false"
        on:dragenter={() => onDragHovering()}
        class:is-active={hovering === index}
      >
        {n.name}
        <button class="icon-button" on:click={(e) => onDeleteAsset(n)}>
          <span class="material-icons"> cancel </span>
        </button>
      </div>
    {/each}
  </div>
{/if}

<style src="./playlist.scss"></style>
